import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';


@Component({
  selector: 'app-pesquisar-resultados',
  templateUrl: './pesquisar-resultados.component.html',
  styleUrls: ['./pesquisar-resultados.component.css']
})
export class PesquisarResultadosComponent implements OnInit {
  hideCL: boolean = false;
  nomeCidade: any = '';
  qBuscado: any = '';
  arrResults: any[] = [];
  arrResultsG: any[] = [];
  urlFoto: any = '';
  meuindexl: any = 0;
  meuindexg: any = 0;
  loadMore: boolean = false;

  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.hideCL = true;
    this.tmaService.eventoFS(true);
    //this.nomeCidade = this.route.snapshot.paramMap.get('cidade');
    this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
    this.qBuscado = this.route.snapshot.paramMap.get('parametrobusca');
    //this.arrResults.push({qq: 1});
    if(this.tmaService.tempPesquisaIdxL != 0 || this.tmaService.tempPesquisaIdxG != 0){
      //ja carregados
      this.renderizarResultados();
    }
    else{
      //do zero
      this.obterResultados();
    }
    
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }


  obterResultados() :void{
    this.hideCL = false;
    var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&indexl=' + this.meuindexl + '&indexg=' + this.meuindexg;
    this.tmaService.getUsuarios(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        var contaL = qRes['dadosPesquisaL'].length;
        var contaG = qRes['dadosPesquisaG'].length;
        
        
        this.arrResults = this.arrResults.concat(qRes['dadosPesquisaL']);
        this.arrResultsG =  this.arrResultsG.concat(qRes['dadosPesquisaG']);
        this.tmaService.tempPessoasL = this.arrResults;
        this.tmaService.tempPessoasG = this.arrResultsG;
        this.tmaService.tempPesquisaIdxL = this.meuindexl;
        this.tmaService.tempPesquisaIdxG = this.meuindexg;
        this.tmaService.tempTermo = this.qBuscado;

        if(contaL == 0 && contaG == 0 ){
          this.loadMore = false;
        }
        else{
          this.loadMore = true;
        }

        this.meuindexl += contaL;
        this.meuindexg += contaG;
        this.tmaService.tempPesquisaIdxL += contaL;
        this.tmaService.tempPesquisaIdxG += contaG;
        
      }
    })
  }

  renderizarResultados() :void{
    this.loadMore = true;
    this.arrResults = this.arrResults.concat(this.tmaService.tempPessoasL);
    this.arrResultsG =  this.arrResultsG.concat(this.tmaService.tempPessoasG);
    this.meuindexl = this.tmaService.tempPesquisaIdxL;
    this.meuindexg = this.tmaService.tempPesquisaIdxG;
    this.qBuscado = this.tmaService.tempTermo;
    setTimeout(() => {
      document.querySelector('#' + this.tmaService.tempPesquisaRef + '_' + this.tmaService.tempPesquisaPos).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 500);
  }

  novaPesquisa() :void{
    this.router.navigate(['/pesquisando/pessoas']);
  }
  
  goPerfil(nomeusuario: any, indexClick: any, referencia: any) :void{
    this.tmaService.tempPesquisaPos = indexClick;
    this.tmaService.tempPesquisaRef = referencia;
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(['/' + nomeusuario]);
  }

  voltar() :void{
    //this._location.back();
    this.router.navigate(['/pesquisando/pessoas']);
  }
}
